import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialsSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const content = {
    en: {
      title: 'What Our Clients Say',
      subtitle: 'Testimonials from Satisfied Clients',
      testimonials: [
        {
          id: 1,
          name: 'Sarah Wanjiku',
          role: 'Business Owner',
          company: 'Wanjiku Enterprises Ltd',
          image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Corporate Law',
          testimonial: `Peter & Partners handled our company incorporation and contract negotiations with exceptional professionalism. Their attention to detail and strategic advice helped us avoid potential legal pitfalls. I highly recommend their services to any business owner.`,
          date: 'March 2024'
        },
        {
          id: 2,
          name: 'David Kimani',
          role: 'Property Developer',
          company: 'Kimani Properties',
          image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Property Law',
          testimonial: `The team successfully resolved a complex property dispute that had been ongoing for two years. Their expertise in property law and negotiation skills resulted in a favorable outcome. Professional, reliable, and results-oriented.`,
          date: 'February 2024'
        },
        {
          id: 3,
          name: 'Grace Muthoni',
          role: 'Individual Client',
          company: null,
          image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Family Law',
          testimonial: `During a difficult divorce proceeding, Peter & Partners provided compassionate yet strong legal representation. They protected my interests while maintaining professionalism throughout the process. I'm grateful for their support during a challenging time.`,
          date: 'January 2024'
        },
        {
          id: 4,
          name: 'Michael Ochieng',role: 'CEO',company: 'TechStart Kenya',image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',rating: 5,caseType: 'Employment Law',
          testimonial: `Their employment law expertise helped us navigate complex labor regulations and establish proper HR policies. The team is knowledgeable, responsive, and provides practical solutions. Excellent legal partnership for growing businesses.`,
          date: 'December 2023'
        },
        {
          id: 5,
          name: 'Jane Nyambura',role: 'Entrepreneur',company: 'Nyambura Consulting',image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',rating: 5,caseType: 'Contract Law',
          testimonial: `Peter & Partners drafted and reviewed multiple contracts for my consulting business. Their thorough approach and clear explanations helped me understand complex legal terms. They're my go-to legal advisors for all business matters.`,
          date: 'November 2023'
        },
        {
          id: 6,
          name: 'Robert Kariuki',
          role: 'Individual Client',
          company: null,
          image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Criminal Defense',
          testimonial: `When I faced criminal charges, Peter & Partners provided exceptional defense representation. Their thorough investigation and strategic approach led to case dismissal. Professional, dedicated, and highly skilled legal team.`,
          date: 'October 2023'
        }
      ]
    },
    sw: {
      title: 'Wateja Wetu Wanasema Nini',
      subtitle: 'Ushuhuda kutoka kwa Wateja Walioridhi',
      testimonials: [
        {
          id: 1,
          name: 'Sarah Wanjiku',
          role: 'Mmiliki wa Biashara',
          company: 'Wanjiku Enterprises Ltd',
          image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Sheria ya Makampuni',
          testimonial: `Peter & Partners walishughulikia kuanzishwa kwa kampuni yetu na mazungumzo ya mikataba kwa utaalamu wa kipekee. Uangalifu wao wa kina na ushauri wa kimkakati ulitusaidia kuepuka mitego ya kisheria. Ninapendekeza huduma zao kwa mmiliki yeyote wa biashara.`,
          date: 'Machi 2024'
        },
        {
          id: 2,
          name: 'David Kimani',
          role: 'Msanidi wa Mali',
          company: 'Kimani Properties',
          image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Sheria ya Mali',
          testimonial: `Timu ilifanikiwa kutatua mgogoro wa mali wa kigumu ambao ulikuwa ukiendelea kwa miaka miwili. Utaalamu wao katika sheria ya mali na ujuzi wa mazungumzo ulisababisha matokeo mazuri. Wataalamu, wanategemeka, na wanaolenga matokeo.`,
          date: 'Februari 2024'
        },
        {
          id: 3,
          name: 'Grace Muthoni',
          role: 'Mteja Binafsi',
          company: null,
          image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Sheria ya Familia',
          testimonial: `Wakati wa mchakato mgumu wa talaka, Peter & Partners walitoa uwakilishi wa kisheria wa huruma lakini imara. Walilinda maslahi yangu huku wakidumisha utaalamu katika mchakato wote. Ninashukuru msaada wao wakati wa changamoto.`,
          date: 'Januari 2024'
        },
        {
          id: 4,
          name: 'Michael Ochieng',
          role: 'Mkurugenzi Mkuu',
          company: 'TechStart Kenya',
          image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Sheria ya Ajira',
          testimonial: `Utaalamu wao wa sheria ya ajira ulitusaidia kuvuka kanuni ngumu za kazi na kuanzisha sera sahihi za HR. Timu ni ya kujua, inajibu, na inatoa suluhisho za vitendo. Ushirikiano mzuri wa kisheria kwa biashara zinazokua.`,
          date: 'Desemba 2023'
        },
        {
          id: 5,
          name: 'Jane Nyambura',
          role: 'Mjasiriamali',
          company: 'Nyambura Consulting',
          image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Sheria ya Mikataba',
          testimonial: `Peter & Partners waliandika na kukagua mikataba mingi kwa biashara yangu ya ushauri. Mbinu yao ya kina na maelezo wazi yalinisaidia kuelewa maneno magumu ya kisheria. Ni washauri wangu wa kisheria wa kwanza kwa mambo yote ya biashara.`,
          date: 'Novemba 2023'
        },
        {
          id: 6,
          name: 'Robert Kariuki',
          role: 'Mteja Binafsi',
          company: null,
          image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          rating: 5,
          caseType: 'Utetezi wa Jinai',
          testimonial: `Nilipokabiliwa na mashtaka ya jinai, Peter & Partners walitoa uwakilishi wa kipekee wa utetezi. Uchunguzi wao wa kina na mbinu ya kimkakati vilisababisha kesi kuondolewa. Timu ya kisheria ya kitaalamu, ya kujitolea, na ya ujuzi wa hali ya juu.`,
          date: 'Oktoba 2023'
        }
      ]
    }
  };

  const currentContent = content[currentLanguage];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        className={index < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}
      />
    ));
  };

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary">
            {currentContent.title}
          </h2>
          <p className="text-xl font-heading font-semibold text-primary">
            {currentContent.subtitle}
          </p>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            {currentLanguage === 'en' ?'Hear from our clients about their experiences working with Peter & Partners Advocates LLP.' :'Sikia kutoka kwa wateja wetu kuhusu uzoefu wao wa kufanya kazi na Peter & Partners Advocates LLP.'
            }
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {currentContent.testimonials.map((testimonial) => (
            <div key={testimonial.id} className="card p-6 space-y-4 hover:shadow-lg transition-shadow duration-300">
              {/* Header */}
              <div className="flex items-start space-x-4">
                <div className="relative">
                  <Image
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center">
                    <Icon name="Quote" size={12} color="white" />
                  </div>
                </div>
                
                <div className="flex-1 min-w-0">
                  <h4 className="font-heading font-semibold text-text-primary truncate">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-text-secondary">
                    {testimonial.role}
                  </p>
                  {testimonial.company && (
                    <p className="text-xs font-caption text-primary">
                      {testimonial.company}
                    </p>
                  )}
                </div>
              </div>

              {/* Rating */}
              <div className="flex items-center space-x-2">
                <div className="flex space-x-1">
                  {renderStars(testimonial.rating)}
                </div>
                <span className="text-sm font-caption text-text-secondary">
                  {testimonial.rating}.0
                </span>
              </div>

              {/* Case Type */}
              <div className="inline-flex items-center space-x-1 bg-surface/20 text-primary px-2 py-1 rounded text-xs font-caption">
                <Icon name="Scale" size={12} />
                <span>{testimonial.caseType}</span>
              </div>

              {/* Testimonial */}
              <blockquote className="text-text-secondary text-sm leading-relaxed">
                "{testimonial.testimonial}"
              </blockquote>

              {/* Date */}
              <div className="flex items-center justify-between pt-2 border-t border-border-light">
                <div className="flex items-center space-x-1 text-xs font-caption text-text-secondary">
                  <Icon name="Calendar" size={12} />
                  <span>{testimonial.date}</span>
                </div>
                <div className="flex items-center space-x-1 text-xs font-caption text-primary">
                  <Icon name="CheckCircle" size={12} />
                  <span>{currentLanguage === 'en' ? 'Verified' : 'Imethibitishwa'}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="card p-8 bg-gradient-to-br from-primary/5 to-accent/5">
            <Icon name="MessageCircle" size={48} className="text-primary mx-auto mb-4" />
            <h3 className="text-2xl font-heading font-bold text-text-primary mb-4">
              {currentLanguage === 'en' ? 'Ready to Share Your Success Story?' : 'Uko Tayari Kushiriki Hadithi Yako ya Mafanikio?'}
            </h3>
            <p className="text-text-secondary leading-relaxed max-w-2xl mx-auto mb-6">
              {currentLanguage === 'en' ?'Join our satisfied clients and experience the difference that professional legal representation can make for your case.' :'Jiunge na wateja wetu walioridhi na upate uzoefu wa tofauti ambayo uwakilishi wa kitaalamu wa kisheria unaweza kufanya kwa kesi yako.'
              }
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+254721320787"
                className="inline-flex items-center justify-center space-x-2 bg-primary text-white px-6 py-3 rounded-lg hover:bg-accent transition-colors duration-200 focus-ring"
              >
                <Icon name="Phone" size={20} />
                <span>{currentLanguage === 'en' ? 'Call Now' : 'Piga Simu Sasa'}</span>
              </a>
              <a
                href="https://wa.me/254721320787"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center space-x-2 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors duration-200 focus-ring"
              >
                <Icon name="MessageCircle" size={20} />
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;